const ChatSoundType = {
    TEXT_MESSAGE: "text_message",
};

export default ChatSoundType;